export enum QueryKeys {
  GLO_JAM_PRICING_VERSIONS = 'GLO_JAM_PRICING_VERSIONS',
  GLO_JAM_PRICING_VERSION = 'GLO_JAM_PRICING_VERSION',
  GLO_JAM_PRICING_RULES = 'GLO_JAM_PRICING_RULES',
  GLO_JAM_REVIEW_MATCHES = 'GLO_JAM_REVIEW_MATCHES',
  GLO_JAM_REVIEW_MATCH_SUMMARIES = 'GLO_JAM_REVIEW_MATCH_SUMMARIES',
  GLO_JAM_MATCH_PRIORITIES = 'GLO_JAM_MATCH_PRIORITIES',
  GLO_JAM_UNIQUE_JOB_CODE_KEYS = 'GLO_JAM_UNIQUE_JOB_CODE_KEYS',
  GLO_JAM_MARKET_ELEMENTS = 'GLO_JAM_MARKET_ELEMENTS',
  RULES_BASED_PRICING_LIST = 'RULES_BASED_PRICING_LIST',
  RULES_BASED_PRICING_DATA_CUTS = 'RULES_BASED_PRICING_DATA_CUTS'
}
